// Prevent duplicate initialization if script is loaded multiple times
if (typeof window.adventCalendarInitialized === 'undefined') {
    window.adventCalendarInitialized = true;

    // Storage key constants for auto-popup
    const STORAGE_KEY_PREFIX = 'wunderle_advent_popup_';
    const STORAGE_KEY_DAY = STORAGE_KEY_PREFIX + 'last_shown_day';
    const STORAGE_KEY_SESSION = STORAGE_KEY_PREFIX + 'session_shown';

    document.addEventListener('DOMContentLoaded', function() {
    // Get all the days
    const days = document.querySelectorAll('.calendar-wrapper > .calendar-day:not(.calendar-day-popup)');

    // Add event listeners for each day
    days.forEach(function(day) {
        day.addEventListener('click', function() {
            const modalTarget = day.getAttribute('data-modal-target');
            if (!modalTarget) return;

            const popup = document.getElementById(modalTarget);
            if (!popup) return;

            // Open the popup
            openModal(popup);
        });
    });

    // Setup close handlers for all modals
    setupModalHandlers();

    // Setup door opening animation for all popup doors
    setupDoorAnimation();

    // Check for auto-popup trigger
    initAutoPopup();
});

/**
 * Open a modal popup
 */
function openModal(popup) {
    if (!popup) return;
    popup.style.display = 'flex';
}

/**
 * Close a modal popup
 */
function closeModal(popup) {
    if (!popup) return;
    popup.style.display = 'none';
}

/**
 * Setup modal handlers (close buttons, copy code, click outside)
 */
function setupModalHandlers() {
    const allModals = document.querySelectorAll('.popup-modal');

    allModals.forEach(function(popup) {
        const closeBtn = popup.querySelector('.popup-close');
        const copyCodeBox = popup.querySelector('.popup-copy-code-box');

        // Close button handler
        if (closeBtn) {
            closeBtn.addEventListener('click', function() {
                closeModal(popup);
            });
        }

        // Click outside to close
        window.addEventListener('click', function(event) {
            if (event.target === popup) {
                closeModal(popup);
            }
        });

        // Copy code functionality
        if (copyCodeBox) {
            copyCodeBox.addEventListener('click', function() {
                const dayCodeBox = popup.querySelector('.popup-day-code-box');
                if (!dayCodeBox) return;

                const couponCode = dayCodeBox.textContent;

                // Copy to clipboard
                navigator.clipboard.writeText(couponCode).then(function() {
                    copyCodeBox.classList.add('copy-successful');

                    setTimeout(function() {
                        copyCodeBox.classList.remove('copy-successful');
                    }, 1000);
                }).catch(function(err) {
                    console.warn('Failed to copy coupon code:', err);
                });
            });
        }
    });
}

/**
 * Initialize auto-popup functionality
 */
function initAutoPopup() {
    const trigger = document.getElementById('advent-calendar-popup-trigger');
    if (!trigger) {
        console.log('No active day for auto-popup, exit early');
        return;
    }

    const frequency = trigger.getAttribute('data-popup-frequency');
    const currentDay = trigger.getAttribute('data-day');
    const delay = parseInt(trigger.getAttribute('data-popup-delay')) || 30;

    // Check if popup should be shown
    if (shouldShowPopup(frequency, currentDay)) {
        // Show popup after delay
        setTimeout(function() {
            showAutoPopup(trigger);
            markPopupAsShown(frequency, currentDay);
        }, delay * 1000); // Convert seconds to milliseconds
    }
}

/**
 * Check if popup should be displayed based on frequency setting
 */
function shouldShowPopup(frequency, currentDay) {
    if (frequency === 'once_per_day') {
        return shouldShowOncePerDay(currentDay);
    } else if (frequency === 'once_per_session') {
        return shouldShowOncePerSession();
    }
    return true; // Default: always show
}

/**
 * Once per day logic - checks if popup was already shown today
 */
function shouldShowOncePerDay(currentDay) {
    try {
        const lastShownDay = localStorage.getItem(STORAGE_KEY_DAY);

        // Show if never shown
        if (!lastShownDay) return true;

        // Create today's date string: YYYY-MM-DD-DayNumber
        const today = new Date();
        const todayString = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}-${currentDay}`;

        // Show if different day
        return lastShownDay !== todayString;
    } catch (e) {
        // If localStorage not available, always show
        console.warn('localStorage not available:', e);
        return true;
    }
}

/**
 * Once per session logic - checks if popup was already shown this session
 */
function shouldShowOncePerSession() {
    try {
        const sessionShown = sessionStorage.getItem(STORAGE_KEY_SESSION);
        return sessionShown !== 'true';
    } catch (e) {
        // If sessionStorage not available, always show
        console.warn('sessionStorage not available:', e);
        return true;
    }
}

/**
 * Mark popup as shown in storage
 */
function markPopupAsShown(frequency, currentDay) {
    try {
        if (frequency === 'once_per_day') {
            const today = new Date();
            const todayString = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}-${currentDay}`;
            localStorage.setItem(STORAGE_KEY_DAY, todayString);
        } else if (frequency === 'once_per_session') {
            sessionStorage.setItem(STORAGE_KEY_SESSION, 'true');
        }
    } catch (e) {
        console.warn('Storage not available:', e);
    }
}

/**
 * Show the auto-popup
 */
function showAutoPopup(trigger) {
    // Get the modal ID from trigger
    const modalId = trigger.getAttribute('data-modal-id');
    if (!modalId) return;

    // Find the pre-rendered modal
    const popup = document.getElementById(modalId);
    if (!popup) return;

    // Open the modal (data is already in HTML)
    openModal(popup);

    // Setup door animation for this popup
    setupDoorAnimation();
}

/**
 * Global door opening animation setup
 * Works with any element that has .popup-door class
 */
function setupDoorAnimation() {
    const allDoors = document.querySelectorAll('.popup-door');

    allDoors.forEach(function(popupDoor) {
        const popupDoorImage = popupDoor.querySelector('.popup-door-image');
        const popupDoorContent = popupDoor.querySelector('.popup-door-content');
        const productBox = popupDoor.querySelector('.popup-product-box');
        const copyCodeBox = popupDoor.querySelector('.popup-copy-code-box');

        if (!popupDoor) return;

        popupDoor.addEventListener('click', function() {
            // Add opening animation class to the image
            if (popupDoorImage) {
                popupDoorImage.classList.add('door-opening');
            }

            // After animation, hide image and show content
            setTimeout(function() {
                // Remove calendar-day and current-day classes from parent
                popupDoor.classList.remove('calendar-day', 'current-day');

                if (popupDoorImage) popupDoorImage.style.display = 'none';
                if (popupDoorContent) popupDoorContent.style.display = 'block';

                // Show the appropriate reward (product or coupon)
                if (productBox && productBox.querySelector('.product-title')?.textContent) {
                    productBox.style.display = 'inline-block';
                } else if (copyCodeBox && copyCodeBox.querySelector('.popup-day-code-box')?.textContent) {
                    copyCodeBox.style.display = 'block';
                }
            }, 600); // Match CSS animation duration
        }, { once: true }); // Only allow one click
    });
}

} // End of duplicate initialization check
